import React, { FC, ReactNode } from 'react';
import { Route, Redirect }      from 'react-router-dom';
import { RouterUtility }        from '../../../../util';
import { useCurrentUser }       from '../../../../hooks';

interface RedirectComponentProps {
	component?: any,
	
	render?( props?: any ): ReactNode | React.ElementType,
	
	[ additionalProps: string ]: any
}

const defaultProps: RedirectComponentProps = {
	component: null
}

const RedirectComponent: FC<RedirectComponentProps> = ( props ) => {
	
	let { render, component: Component, ...rest } = props;
	
	let { currentUser } = useCurrentUser( { errorPolicy: 'ignore' } );
	
	// If we have a user object, render the specified component,
	// otherwise redirect to login page
	return (
		<Route { ...rest } render={ ( props: any ) => {
			
			if( currentUser ){
				
				return render ? render( props ) : <Component { ...props } />
				
			} else {
				
				return <Redirect to={ RouterUtility.getLoginURL( props.location.pathname ) } { ...props }/>
			}
		} }/>
	);
};

RedirectComponent.defaultProps = defaultProps;

export { RedirectComponent as PrivateRoute };
